<template>
	<ValidationProvider :vid="idLabel" :rules="{ required: required }" :immediate="immediate" v-slot="{ failed }" slim>
		<div :class="{ 'form-group': true, 'radio-group-wrapper': true, 'is-invalid-wrapper': failed }">
			<p class="label">
				<strong>{{ label }}</strong><template v-if="limit"> (Select up to {{ limit }})</template>
				<span class="required" v-if="required">*</span>
			</p>

			<template v-for="(option, key) in options">
				<check-input
					:value="value"
					:key="key"
					:label="objectOptions ? key : option"
					:checkedValue="objectOptions ? key : option"
					:disabled="limit && Array.isArray(value) && value.length > limit - 1 && value.indexOf(option) === -1"
					@input="(newValue) => $emit('input', newValue)"
				>
					{{ objectOptions ? key : option }}
				</check-input>

				<transition name="slide" :key="'transition-' + key">
					<div class="ml-5" v-if="Array.isArray(option) && value.indexOf(key) !== -1">
						<check-input
							:value="value"
							v-for="(option2, key2) in option"
							:key="key2"
							:label="objectOptions ? key2 : option2"
							:checkedValue="key + ':' + option2"
							@input="(newValue) => $emit('input', newValue)"
						>
							{{ option2 }}
						</check-input>
					</div>
				</transition>
			</template>
		</div>
	</ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import formControlProps from '../Mixins/formControlProps';
import validationProps from '../Mixins/validationProps';
import checkInput from './CheckInput';
import '../Utils/validation';

export default {
	mixins: [formControlProps, validationProps],

	props: {
		value: [Array, String],
		options: [Array, Object],
		limit: Number
	},

	computed: {
		objectOptions() {
			return !Array.isArray(this.options);
		},
	},

	components: {
		ValidationProvider,
		checkInput,
	},
};
</script>
